import { render, staticRenderFns } from "./ZahnwerkstattDataPrivacyPage.vue?vue&type=template&id=60ccbdb6&scoped=true"
import script from "./ZahnwerkstattDataPrivacyPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattDataPrivacyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ccbdb6",
  null
  
)

export default component.exports